import Container from "@/components/Container";
import { useQuery } from "@/hooks";
import { Typography } from "@mui/material";
import { useEffect } from "react";

const BimqCallback = () => {
    const query = useQuery();

    useEffect(() => {
        const code = query.get("code");

        window.opener.postMessage({
            type: "BIMQ-AUTH-RESPONSE",
            payload: { code },
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container>
            <Typography variant="body2">Authenticating...</Typography>
        </Container>
    );
};

export default BimqCallback;
